'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import PropTypes from 'prop-types';
export default function UIAbstractPageSection(props) {
  const {
    className
  } = props,
        rest = _objectWithoutPropertiesLoose(props, ["className"]);

  return /*#__PURE__*/_jsx("section", Object.assign({}, rest, {
    className: classNames('private-template__section', className)
  }));
}
UIAbstractPageSection.propTypes = {
  children: PropTypes.node
};
UIAbstractPageSection.displayName = 'UIAbstractPageSection';